import React from 'react';
import { Box, Container, Typography, Paper, Divider } from '@mui/material';
import { SEOHead, SEO_PAGES } from '../seo/SEOHead';

export const PrivacyPage: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <SEOHead {...SEO_PAGES.privacy} />
      <Paper sx={{ p: 4 }}>
        <Typography variant="h3" gutterBottom sx={{ fontWeight: 700 }}>
          Privacy Policy
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Last updated: January 2026
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ '& h5': { mt: 4, mb: 2, fontWeight: 600 }, '& p': { mb: 2 } }}>
          <Typography variant="h5">1. Introduction</Typography>
          <Typography>
            GovToolsPro ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our Chrome extension and website.
          </Typography>

          <Typography variant="h5">2. Information We Collect</Typography>
          <Typography>
            <strong>Account Information:</strong> When you create an account, we collect your email address and authentication credentials.
          </Typography>
          <Typography>
            <strong>Usage Data:</strong> We collect information about how you use our extension, including pages visited on SAM.gov and features used within the extension.
          </Typography>
          <Typography>
            <strong>Device Information:</strong> We may collect browser type, operating system, and device identifiers for analytics and troubleshooting.
          </Typography>

          <Typography variant="h5">3. How We Use Your Information</Typography>
          <Typography>
            We use the information we collect to:
          </Typography>
          <Typography component="div">
            • Provide and maintain our services<br />
            • Improve and personalize user experience<br />
            • Process transactions and send related information<br />
            • Send administrative information and updates<br />
            • Respond to inquiries and offer support<br />
            • Monitor and analyze usage patterns
          </Typography>

          <Typography variant="h5">4. Data Storage and Security</Typography>
          <Typography>
            Your data is stored securely using Firebase services provided by Google. We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
          </Typography>

          <Typography variant="h5">5. Third-Party Services</Typography>
          <Typography>
            Our extension accesses publicly available data from government websites including SAM.gov, USAspending.gov, and FPDS.gov. We do not control and are not responsible for the privacy practices of these third-party sites.
          </Typography>

          <Typography variant="h5">6. Data Sharing</Typography>
          <Typography>
            We do not sell, trade, or rent your personal information to third parties. We may share anonymized, aggregated data for analytics purposes.
          </Typography>

          <Typography variant="h5">7. Your Rights</Typography>
          <Typography>
            You have the right to:
          </Typography>
          <Typography component="div">
            • Access your personal data<br />
            • Correct inaccurate data<br />
            • Request deletion of your data<br />
            • Opt-out of marketing communications<br />
            • Export your data
          </Typography>

          <Typography variant="h5">8. Cookies and Tracking</Typography>
          <Typography>
            Our website uses cookies to enhance user experience and analyze site traffic. You can control cookie preferences through your browser settings.
          </Typography>

          <Typography variant="h5">9. Children's Privacy</Typography>
          <Typography>
            Our services are not intended for users under 18 years of age. We do not knowingly collect personal information from children.
          </Typography>

          <Typography variant="h5">10. Changes to This Policy</Typography>
          <Typography>
            We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
          </Typography>

          <Typography variant="h5">11. Contact Us</Typography>
          <Typography>
            If you have questions about this Privacy Policy, please contact us at:
          </Typography>
          <Typography>
            Email: support@govtoolspro.com
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};
